import React, { useState } from 'react';
import { Container, Form, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/auth/login', { username, password });
            localStorage.setItem('token', res.data.token);
            navigate('/');
        } catch (err) {
            alert("Identifiants incorrects");
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center vh-100">
            <Card style={{ width: '400px' }} className="p-4 shadow">
                <h2 className="text-center mb-4">Streaming Privé</h2>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Utilisateur</Form.Label>
                        <Form.Control type="text" onChange={e => setUsername(e.target.value)} required />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Mot de passe</Form.Label>
                        <Form.Control type="password" onChange={e => setPassword(e.target.value)} required />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="w-100">Connexion</Button>
                </Form>
            </Card>
        </Container>
    );
};

export default Login;